import React, { useEffect, useState } from 'react';
import { useLayoutContext } from '../../providers/LayoutProvider';
import { AccentedText } from '../AccentedText/AccentedText';
import { DOMParseHTMLElement } from '../../shared/stripHtml';
import { isURLValid, queryBuilder } from '../../shared/Utils';
import './ContactUs.scss';
import { IconList } from './IconList';

export const ContactUs = ({ node }) => {
    const { campaignTermsFilter } = useLayoutContext();
    const [queryString, setQueryString] = useState(``);
    const heading = node.field_heading;
    const eyebrow = node.field_eyebrow_text;
    const bodyText = node.field_content_text?.value;
    const icons = node.relationships?.field_icon_list;
    const embeddedCode = node.field_embed_code;
    const queryParametersToString = queryBuilder(campaignTermsFilter, false);
    const srcString =
        DOMParseHTMLElement(embeddedCode)?.querySelector(`iframe`)?.src;

    useEffect(() => {
        setQueryString(
            `${!queryParametersToString ? `` : queryParametersToString}`
        );
    }, [queryParametersToString]);

    return (
        <section className="c--contact-us themed-container dark">
            <div className="kite-container">
                <div className="c--text-content">
                    {(heading || eyebrow) && (
                        <h2 className="typestack-title-1">
                            {eyebrow && (
                                <span className="eyebrow">{eyebrow}</span>
                            )}
                            {heading && (
                                <span>
                                    <AccentedText>{heading}</AccentedText>
                                </span>
                            )}
                        </h2>
                    )}
                    {bodyText && (
                        <div
                            className="body"
                            dangerouslySetInnerHTML={{ __html: bodyText }}
                        ></div>
                    )}
                </div>
                <div className="iframe-container light">
                    <h3>Get in touch.</h3>
                    <p className="typestack-caption">
                        All fields required unless marked otherwise
                    </p>
                    {isURLValid(srcString) && (
                        <div className="iframe-form-wrapper">
                            <iframe
                                title="Get In Touch"
                                data-id="contact-us"
                                src={`${srcString}${queryString}`}
                                frameBorder="0"
                                style={{ border: 0 }}
                                allow="transparency"
                                width="100%"
                            ></iframe>
                        </div>
                    )}
                </div>
                {icons && <IconList node={icons} />}
            </div>
        </section>
    );
};
